export default function iff(val) {
  return !!val
}


/** WEBPACK FOOTER **
 ** ./client/lib/iff.js
 **/